import debug from 'debug';

import { setApiPublicV2Client } from '@mi-front/api-public-v2';
import { setApiV2Client } from '@mi-front/api-v2';
import { BRAND_ASSETS_BASE } from '@mi-front/ui';
import { Inspector } from 'react-dev-inspector';
import { createRoot } from 'react-dom/client';
import 'react-loading-skeleton/dist/skeleton.css';
import 'video.js/dist/video-js.css';
import { apiClient as newApiClient } from './api';
import { config } from './config';
import { Root } from './core/containers/Root';
import './setup';
import './styles/ui.css';
debug.log = console.log.bind(console);
debug.enable('*');

const MOUNT_NODE = document.getElementById('root');

setApiV2Client(newApiClient, { apiRoot: config.apiV2Root });
setApiPublicV2Client(newApiClient, { apiRoot: config.apiV2Root });

const favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
if (favicon) {
  favicon.href = config.isAppDev
    ? `${BRAND_ASSETS_BASE}/favicon-dev.png`
    : `${BRAND_ASSETS_BASE}/favicon.ico`;
}

/** Mounts the React app with the React 18 createRoot API. */
function render() {
  if (!MOUNT_NODE) {
    throw new Error('Root mount node not found');
  }

  createRoot(MOUNT_NODE).render(
    <>
      {config.isNodeDev && <Inspector keys={['Control', 'Shift', 'C']} />}
      <Root />
    </>,
  );
}

render();

console.info(`MediaInbox UI ${config.appEnv.toUpperCase()} ${config.appVersion}`);
